<div class="edit-container">
    <h1 class="edit-title">Actualizare copil</h1>
    <form class="edit-card__form" [formGroup]="form" (submit)="submitForm()">
        <div class="row">
            <div class="col">
                <mat-form-field class="w-100" appearance="fill">
                    <mat-label>Nume</mat-label>
                    <input type="text" matInput formControlName="last_name" />
                    <mat-error *ngIf="!form.controls['last_name'].valid && form.controls['last_name'].touched">
                        Câmp obligatoriu
                    </mat-error>
                </mat-form-field>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <mat-form-field class="w-100" appearance="fill">
                    <mat-label>Prenume</mat-label>
                    <input type="text" matInput formControlName="first_name" />
                    <mat-error *ngIf="!form.controls['first_name'].valid && form.controls['first_name'].touched">
                        Câmp obligatoriu
                    </mat-error>
                </mat-form-field>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <mat-form-field class="w-100" appearance="fill">
                    <mat-label>Părinții</mat-label>
                    <input type="text" matInput formControlName="parintii" />
                    <mat-error *ngIf="!form.controls['parintii'].valid && form.controls['parintii'].touched">
                        Câmp obligatoriu
                    </mat-error>
                </mat-form-field>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <mat-form-field class="w-100" appearance="fill">
                    <mat-label>Data nașterii</mat-label>
                    <input matInput [matDatepicker]="birthDatePicker" formControlName="birth_date" readonly
                        (focus)="birthDatePicker.open()" />
                    <mat-hint>ZZ/LL/AAAA</mat-hint>
                    <mat-datepicker-toggle matIconSuffix [for]="birthDatePicker"></mat-datepicker-toggle>
                    <mat-datepicker #birthDatePicker></mat-datepicker>
                    <mat-error *ngIf="!form.controls['birth_date'].valid && form.controls['birth_date'].touched">
                        Câmp obligatoriu
                    </mat-error>
                </mat-form-field>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <mat-form-field class="w-100" appearance="fill">
                    <mat-label>Cnp</mat-label>
                    <input type="text" matInput formControlName="cnp" />
                    <mat-error *ngIf="!form.controls['cnp'].valid && form.controls['cnp'].touched">
                        Câmp obligatoriu
                    </mat-error>
                </mat-form-field>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <mat-form-field class="w-100" appearance="fill">
                    <mat-label>Locație</mat-label>
                    <input type="text" matInput formControlName="locatie" />
                    <mat-error *ngIf="!form.controls['locatie'].valid && form.controls['locatie'].touched">
                        Câmp obligatoriu
                    </mat-error>
                </mat-form-field>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <mat-form-field class="w-100" appearance="fill">
                    <mat-label>Email</mat-label>
                    <input type="email" matInput formControlName="email" />
                    <mat-error *ngIf="!form.controls['email'].valid && form.controls['email'].touched">
                        Câmp obligatoriu
                    </mat-error>
                </mat-form-field>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <mat-form-field class="w-100" appearance="fill">
                    <mat-label>Telefon</mat-label>
                    <input type="text" matInput formControlName="telefon" />
                    <mat-error *ngIf="!form.controls['telefon'].valid && form.controls['telefon'].touched">
                        Câmp obligatoriu
                    </mat-error>
                </mat-form-field>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <mat-form-field class="w-100" appearance="fill">
                    <mat-label>Status</mat-label>
                    <input type="text" matInput formControlName="status" />
                    <mat-error *ngIf="!form.controls['status'].valid && form.controls['status'].touched">
                        Câmp obligatoriu
                    </mat-error>
                </mat-form-field>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <mat-form-field class="w-100" appearance="fill">
                    <mat-label>Observații</mat-label>
                    <textarea matInput formControlName="observatii" rows="2"></textarea>
                    <mat-error *ngIf="!form.controls['observatii'].valid && form.controls['observatii'].touched">
                        Câmp obligatoriu
                    </mat-error>
                </mat-form-field>
            </div>
        </div>
        <div class="row">
            <div class="col d-flex justify-content-between">
                <button type="button" class="buttons" mat-flat-button (click)="closeDialog()">
                    {{ helper.dialogConfig.buttonLabels.close }}
                </button>
                <button class="buttons" mat-flat-button color="primary" type="submit" [disabled]="form.invalid">
                    {{ helper.dialogConfig.buttonLabels.save }}
                </button>
            </div>
        </div>
    </form>
    <div class="section-spinner position-absolute" *ngIf="isLoading">
        <div class="spinner position-absolute top-50 start-50 translate-middle">
            <mat-spinner></mat-spinner>
            <h3 class="mt-2">{{ helper.dialogConfig.generalMessages.pleaseWait }}</h3>
        </div>
    </div>
</div>